import React from 'react';
import { useLocation } from 'react-router-dom';
import { NavHashLink } from 'react-router-hash-link';
import styles from "./NavBar.module.css";

const DEFAULT_CLASSES = {
  container: styles.navbar,
  navInner: styles.navInner,
  logoContainer: styles.logoContainer,
  logoImage: styles.logoImage,
  navListLeft: styles.navListLeft,
  navListRight: styles.navListRight,
  navItemContainer: styles.navItemContainer,
  navItem: styles.navLink,
  navItemActive: styles.active,
  navBadge: styles.cartBadge,
  navIcon: styles.navIcon
};

const DEFAULT_LOGO = {
  image: null,
  path: "/"
};

function renderNavItem(item, classes, navStyles, location) {
  const isSection = item.path.startsWith('#');
  const active = isSection
    ? location.pathname === '/home' && location.hash === item.path
    : location.pathname === item.path && !location.hash;

  return (
    <button 
      key={item.name} 
      className={classes.navItemContainer} 
      style={navStyles.navItemContainer}>
      <NavHashLink
        smooth
        to={isSection ? `/home${item.path}` : item.path}
        onClick={() => {
          if (item.scrollToTop) {
            window.scrollTo({ top: 0, left: 0, behavior: "auto" });
          }
        }}
        className={active ? `${classes.navItem} ${classes.navItemActive}` : classes.navItem}
        aria-current={active ? (isSection ? 'location' : 'page') : undefined}
        style={{...navStyles.navItem, ...item.style}}
      >
        {item.name}

        {item.badge && item.badge.value > 0 && (
          <span className={classes.navBadge} style={navStyles.navBadge}>
            {item.badge.value}
          </span>
        )}
        {item.icon && (
          <span className={classes.navIcon} style={navStyles.navIcon}>
            {item.icon}
          </span>
        )}
      </NavHashLink>
    </button>
  );
}

function NavBar({ 
  navItemsLeft = [], 
  navItemsRight = [], 
  navLogo = {}, 
  navClassesOverride = {}, 
  navStyles = {},
}) {

  const location = useLocation();
  const classes = { ...DEFAULT_CLASSES, ...navClassesOverride };
  const logo = { ...DEFAULT_LOGO, ...navLogo };

  return (
    <nav className={classes.container} style={navStyles.container}>
      <div className={classes.navInner} style={navStyles.navInner}>
        <div className={classes.navListLeft} style={navStyles.navListLeft}>
          {navItemsLeft.map((item) => (
            renderNavItem(item, classes, navStyles, location)
          ))}
        </div>
        
        <div className={classes.logoContainer} style={navStyles.logoContainer}>
          <a href={logo.path}>
            <img 
              src={logo.image} 
              alt="Logo" 
              className={classes.logoImage}
              style={navStyles.logoImage}
            />
          </a>
        </div>

        <div className={classes.navListRight} style={navStyles.navListRight}>
          {navItemsRight.map((item) => (
            renderNavItem(item, classes, navStyles, location)
          ))}
        </div>

      </div>

    </nav>
  );
}

export default NavBar;